// StyledComponents.tsx
import { styled } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';

export const ScrollableDialogContent = styled(DialogContent)(({ theme }) => ({
  "&::-webkit-scrollbar": {
    width: "1px", // Set the width of the scrollbar
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#8850ef", // Scrollbar thumb color
    borderRadius: "10px", // Rounded corners
  },
  "&::-webkit-scrollbar-track": {
    background: "#ffffff", // Background for scrollbar track
  },
  scrollbarWidth: "thin", // Firefox
  scrollbarColor: "darkgrey #f1f1f1", // Scrollbar color and background
}));
